import { createRouter, createWebHistory } from "vue-router";
import UserRegister from "./views/UserRegister.vue";
import UserLogin from "./views/UserLogin.vue";
import UserDashboard from "./views/UserDashboard.vue";
import UpdateProfile from "./views/UpdateProfile.vue";
import MyAccounts from "./views/MyAccounts.vue";
import MyProfile from "./views/MyProfile.vue";
import TransactionDetails from "./views/TransactionDetails.vue";
import FundTransfer from "./views/FundTransfer.vue";
import BeneficiaryPayment from "./views/BeneficiaryPayment.vue";
import ForgetPassword from "./views/ForgetPassword.vue";
import LoanRepayment from "./views/LoanRepayment.vue";

const routes = [
    { path: '/register', name : 'UserRegister', component : UserRegister },
    { path: '/', name: 'UserLogin', component: UserLogin },
    { path: '/forgotPassword', name: 'ForgetPassword', component: ForgetPassword },
    { path : '/dashboard', name : 'UserDashboard', component: UserDashboard },
    { path : '/update-profile', name : 'UpdateProfile', component: UpdateProfile, meta: {requiresAuth : true } },
    { path : '/bank-accounts', name : 'BankAccounts', component: MyAccounts, meta: {requiresAuth : true } },
    { path : '/loans', name : 'BankLoans', component: MyAccounts, meta: {requiresAuth : true } },
    { path : '/loanrepayment', name : 'LoanRepayment', component: LoanRepayment, meta: {requiresAuth : true } },
    { path : '/term-deposits', name : 'TermDesposits', component: MyAccounts, meta: {requiresAuth : true } },
    { path : '/account-details', name : 'AccountDetails', component: MyProfile, meta: {requiresAuth : true } },
    { path : '/accountTypes', name : 'AccountTypes', component: MyProfile, meta: {requiresAuth : true } },
    { path : '/bankStatement', name : 'BankStatement', component: TransactionDetails, meta: {requiresAuth : true } },
    { path : '/customBankStatement', name : 'CustomBankStatement', component: TransactionDetails, meta: {requiresAuth : true } },
    { path : '/beneficiary', name : 'BeneficiaryDetails', component: FundTransfer, meta: {requiresAuth : true } },
    { path : '/add-beneficiary', name : 'AddBeneficiary', component: FundTransfer, meta: {requiresAuth : true } },
    { path : '/payment', name : 'BeneficiaryPayment', component: BeneficiaryPayment, meta: {requiresAuth : true } },
];

const router = createRouter({
    history: createWebHistory(), routes
});

router.beforeEach((to, from, next)=>{
    if(to.matched.some(record => record.meta.requiresAuth)){
        const token = localStorage.getItem('token');
        if(!token){
            next({ name : 'UserLogin' })
        }else{
            next();
        }
    }else{
        next();
    }
});

let inactivityTimer;
const logoutTime = 2 * 60 * 1000; // 2 minutes

const resetTimer = () => {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/';
    }, logoutTime);
};

// Detect user activity
window.addEventListener('mousemove', resetTimer);
window.addEventListener('keydown', resetTimer);
resetTimer();

export default router;